/* eslint-disable  */
import { debounce } from "lodash";
import React, { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import {
  FiSearch,
  FiUsers,
  FiCreditCard,
  FiCalendar,
  FiMoreVertical,
  FiTrendingUp,
} from "react-icons/fi";
import { dataActionCreators } from "../../services/Actions";
import { ToastContainer, toast } from "react-toastify";
import { GhanaMoneyDisplay } from "../../helpers/helper";
import { GetTotal } from "../../services/Actions/dataAction";
import Loader from "../../Components/Loader";
import RenderHirePurchasePage from "../RenderHirePurchasePage";

function MartDeduction() {
  const dispatch = useDispatch();
  const { ResetDataResponse, GetAllMartDeductions } = bindActionCreators(
    dataActionCreators,
    dispatch
  );

  const [limit, setLimit] = useState(20);
  const [search, setSearch] = useState(null);
  const [pageCount, setPageCount] = useState(0);

  const data = useSelector((state) => state.data);
  const {
    paginate,
    response,
    mart_deductions,
    total_mart_deductions,
    isLoading,
  } = data;

  useEffect(() => {
    setPageCount(Number(paginate?.total) || 0);
  }, [paginate]);

  const handlePageClick = (event) => {
    GetAllMartDeductions(
      true,
      event.selected + 1,
      limit,
      `${search ? "&search=" + search : ""}`
    );
  };

  const onSearchTextChange = debounce((e) => {
    const val = e?.target?.value;
    setSearch(val || null);
    GetAllMartDeductions(true, 1, limit, val ? `&search=${val}` : "");
  }, 800);

  useEffect(() => {
    GetAllMartDeductions(true, 1, limit);
    dispatch(GetTotal());
  }, []);

  useEffect(() => {
    GetAllMartDeductions(true, 1, limit, search ? "&search=" + search : "");
  }, [limit]);

  useEffect(() => {
    if (response?.state === "SUCCESS") {
      toast.success(response?.message);
      setTimeout(() => ResetDataResponse(), 1500);
    } else if (response?.state === "ERROR") {
      toast.error(response?.message);
      setTimeout(() => ResetDataResponse(), 1500);
    }
  }, [response?.state]);

  return (
    <div>
      <RenderHirePurchasePage title={"Mart Deductions"} page={15}>
        {isLoading && <Loader />}

        {/* --- Top Statistics Card --- */}
        <div className="mb-8 grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="bg-white dark:bg-gray-800 p-6 rounded-2xl shadow-sm border border-gray-100 dark:border-gray-700 flex items-center gap-5">
            <div className="bg-blue-100 dark:bg-blue-900/40 p-4 rounded-xl text-blue-600 dark:text-blue-400">
              <FiTrendingUp size={24} />
            </div>
            <div>
              <p className="text-sm text-gray-500 font-medium italic">
                Total Mart Deductions
              </p>
              <h3 className="text-2xl font-bold text-gray-900 leading-none mt-1">
                <GhanaMoneyDisplay amount={total_mart_deductions || 0} />
              </h3>
            </div>
          </div>
        </div>

        {/* --- Toolbar / Filters --- */}
        <div className="bg-white dark:bg-gray-800 p-4 rounded-xl shadow-sm border border-gray-100 dark:border-gray-700 mb-6 flex flex-col md:flex-row gap-4 items-center justify-between">
          <div className="relative w-full md:max-w-md">
            <FiSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
            <input
              type="search"
              placeholder="Search staff ID or name..."
              className="w-full pl-10 pr-4 py-2 bg-gray-50 dark:bg-gray-700 border border-gray-200 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none transition-all dark:text-gray-100 dark:placeholder-gray-400"
              onChange={onSearchTextChange}
            />
          </div>

          <div className="flex items-center gap-3 w-full md:w-auto">
            <label className="text-sm font-medium text-gray-600 dark:text-gray-300 whitespace-nowrap">
              Show:
            </label>
            <select
              className="bg-white dark:bg-gray-700 border border-gray-200 dark:border-gray-600 rounded-lg px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-blue-500 dark:text-gray-100"
              onChange={(e) => setLimit(e.target.value)}
              value={limit}
            >
              {[20, 50, 100, 250, 500].map((num) => (
                <option key={num} value={num}>
                  {num} rows
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* --- Table Section --- */}
        <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-100 dark:border-gray-700 overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-left border-collapse">
              <thead>
                <tr className="bg-gray-50/80 dark:bg-gray-700/60 border-b border-gray-100 dark:border-gray-600">
                  <th className="px-6 py-4 text-xs font-bold uppercase tracking-wider text-gray-500 dark:text-gray-300">
                    Member Info
                  </th>
                  <th className="px-6 py-4 text-xs font-bold uppercase tracking-wider text-gray-500 dark:text-gray-300">
                    Amount
                  </th>
                  <th className="px-6 py-4 text-xs font-bold uppercase tracking-wider text-gray-500 dark:text-gray-300">
                    Period
                  </th>
                  <th className="px-6 py-4 text-xs font-bold uppercase tracking-wider text-gray-500 dark:text-gray-300">
                    Transaction
                  </th>
                  <th className="px-6 py-4 text-xs font-bold uppercase tracking-wider text-gray-500 dark:text-gray-300 text-right">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-50 dark:divide-gray-700">
                {mart_deductions?.length > 0 ? (
                  mart_deductions.map((loan) => (
                    <tr
                      key={loan?._id}
                      className="hover:bg-gray-50/80 dark:hover:bg-gray-700/60 transition-colors"
                    >
                      <td className="px-6 py-4">
                        <div className="flex items-center gap-3">
                          <img
                            className="w-10 h-10 rounded-full object-cover border-2 border-white dark:border-gray-600 shadow-sm"
                            src={
                              loan?.user?.profile_image ||
                              (loan?.user?.name?.startsWith("Mr")
                                ? "/images/dev/avarta2.jpeg"
                                : "/images/dev/woman-avarta.jpeg")
                            }
                            alt="avatar"
                          />
                          <div>
                            <p className="text-sm font-semibold text-gray-900">
                              {loan?.user?.name}
                            </p>
                            <p className="text-xs text-gray-500 uppercase">
                              {loan?.staff_id}
                            </p>
                          </div>
                        </div>
                      </td>
                      <td className="px-6 py-4">
                        <div className="inline-flex items-center px-2.5 py-0.5 rounded-full text-sm font-bold bg-green-50 dark:bg-green-900/30 text-green-700 dark:text-green-400 border border-green-100 dark:border-green-800">
                          <GhanaMoneyDisplay amount={loan?.deduction} />
                        </div>
                      </td>
                      <td className="px-6 py-4 text-sm text-gray-600 dark:text-gray-400 italic">
                        {loan?.period}
                      </td>
                      <td className="px-6 py-4">
                        <span className="text-sm font-medium text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-gray-700 px-2 py-1 rounded">
                          {loan?.transaction_type}
                        </span>
                        <p className="text-[10px] text-gray-400 mt-1 uppercase tracking-tight">
                          {loan?.user?.facility}
                        </p>
                      </td>
                      <td className="px-6 py-4 text-right">
                        <button className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 transition-colors">
                          <FiMoreVertical size={20} />
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan="5"
                      className="px-6 py-20 text-center text-gray-400"
                    >
                      No deduction records found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* --- Pagination --- */}
          {mart_deductions?.length > 0 && (
            <div className="p-6 border-t border-gray-100 dark:border-gray-700 flex justify-center">
              <ReactPaginate
                breakLabel="..."
                nextLabel="Next"
                previousLabel="Prev"
                onPageChange={handlePageClick}
                pageCount={Math.ceil(pageCount / limit)}
                containerClassName="flex items-center gap-1"
                pageLinkClassName="w-10 h-10 flex items-center justify-center rounded-lg border border-gray-200 dark:border-gray-600 bg-white dark:bg-gray-800 text-sm font-medium text-gray-600 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700"
                previousLinkClassName="px-4 h-10 flex items-center justify-center rounded-lg border border-gray-200 dark:border-gray-600 bg-white dark:bg-gray-800 text-sm font-medium text-gray-500 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 mr-2"
                nextLinkClassName="px-4 h-10 flex items-center justify-center rounded-lg border border-gray-200 dark:border-gray-600 bg-white dark:bg-gray-800 text-sm font-medium text-gray-500 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 ml-2"
                activeLinkClassName="!bg-blue-600 !text-white !border-blue-600 shadow-md shadow-blue-200 dark:shadow-blue-900"
              />
            </div>
          )}
        </div>

        <ToastContainer autoClose={3000} position="bottom-right" />
      </RenderHirePurchasePage>
    </div>
  );
}

export default MartDeduction;
